import type { HydraGetStoreCreditResponse } from '@/lib/services/Hydra/account/GET/getStoreCredit'
import { countryData } from '@/constants/pickerRegions/countryData'
import type { SupportedAlpha3CountryCode } from '../localization/getSupportedAlpha3CountryCodes'

type Props = {
  alpha3: SupportedAlpha3CountryCode
  storeCreditResponse: HydraGetStoreCreditResponse
}

export const getCountryBasedStoreCredit = ({
  alpha3,
  storeCreditResponse,
}: Props) => {
  const country = countryData.find(
    (countryItem) => countryItem.alpha3.toUpperCase() === alpha3.toUpperCase(),
  )

  if (!country) {
    return null
  }

  const currencies = new Set(
    country.currencies.map((currency) => currency.code),
  )

  const availableCurrency = Object.keys(storeCreditResponse.items[0]).find(
    (creditCurrency) => currencies.has(creditCurrency),
  )

  if (!availableCurrency) {
    return null
  }

  return {
    storeCredit: storeCreditResponse.items[0][availableCurrency] || 0,
    availableCurrency,
  }
}
